
export const getLocalSessionId = () => {

    return localStorage.getItem('ksessionid');
};

export const getLocalUserStatus = () => {

    return localStorage.getItem('kstatus');
};

export const getLocalPropertyId = () => {

    return localStorage.getItem('kpropertyid');
};

export const getLocalPropertiesInfo = () => {

    return JSON.parse(localStorage.getItem('kproperties'));
};

export let sessionCleanup = () => {

    localStorage.removeItem('ksessionid');
    localStorage.removeItem('kstatus');
    localStorage.removeItem('kpropertyid');
    localStorage.removeItem('kproperties');

};

export const getStatusRoute = (status) => {

    if (status.includes('onboarding')) {

        return '/' + status.split('_')[1];
    }

    return '/';

};

export let managePropertiesMeta = (propertyList) => {

    let mainPropertyId = '';
    let kProperties = {};

    for (const [propertyId, propertyData] of Object.entries(propertyList)) {

        if (!mainPropertyId) {

            mainPropertyId = propertyId;
        }

        let propertyIntegrations = [];

        for (const [intKey, intData] of Object.entries(propertyData['integrations'])) {

            if (Object.keys(intData).includes('name')) {

                propertyIntegrations.push(intKey);
            }

        }

        kProperties[propertyId] = {
            'name': propertyData['details']['name'],
            'address': propertyData['details']['address'],
            'integrations': propertyIntegrations
        };

    }

    localStorage.setItem('kproperties', JSON.stringify(kProperties));
    localStorage.setItem('kpropertyid', mainPropertyId);

};

export const checkLocalSession = (router) => {

    if (!getLocalSessionId() || !getLocalUserStatus()
        || !getLocalPropertyId() || !getLocalPropertiesInfo()) {

        sessionCleanup();
        router.route('/login')

        return;

    }

    let userStatus = getLocalUserStatus();
    let statusRoute = getStatusRoute(userStatus);

    if (userStatus !== 'active' && statusRoute !== '/'
        && statusRoute !== window.location.pathname) {

        router.route(statusRoute);
    }

};

export const checkUnauthorized = (router, result) => {

    if (result['reason'] === 'unauthorized') {

        sessionCleanup();
        router.route('/login');

        return true;

    }

    return false;

};




